(() => {
  const ENDPOINT = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function initForm(form) {
    const listId = form.dataset.listId;
    const input = form.querySelector('.awe-kf__input');
    const btn = form.querySelector('.awe-kf__btn');
    const errorEl = form.querySelector('.awe-kf__error');
    const successEl = form.querySelector('.awe-kf__success');
    const row = form.querySelector('.awe-kf__row');

    let lastSuggestedEmail = null;

    async function subscribe(email) {
      btn.classList.add('awe-kf__btn--loading');
      btn.disabled = true;

      try {
        const body = new URLSearchParams({ g: listId, email });
        const res = await fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          body,
        });

        const data = await res.json();

        if (data.errors && data.errors.length) {
          throw new Error(data.errors[0]);
        }

        row.style.display = 'none';
        successEl.hidden = false;
      } catch (err) {
        input.setAttribute('aria-invalid', 'true');
        errorEl.textContent =
          err.message && err.message.length < 120
            ? err.message
            : 'Something went wrong. Please try again.';
        errorEl.hidden = false;
        btn.classList.remove('awe-kf__btn--loading');
        btn.disabled = false;
      }
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const email = input.value.trim();

      // Clear previous error
      input.removeAttribute('aria-invalid');
      errorEl.textContent = '';
      errorEl.hidden = true;

      if (!EMAIL_RE.test(email)) {
        input.setAttribute('aria-invalid', 'true');
        errorEl.textContent = 'Please enter a valid email address.';
        errorEl.hidden = false;
        input.focus();
        lastSuggestedEmail = null;
        return;
      }

      const typoCheck = window.AweEmailTypoCheck && window.AweEmailTypoCheck.check(email);

      if (typoCheck && typoCheck.type === 'block') {
        input.setAttribute('aria-invalid', 'true');
        errorEl.textContent = 'Please enter a real email address.';
        errorEl.hidden = false;
        input.focus();
        lastSuggestedEmail = null;
        return;
      }

      if (typoCheck && typoCheck.type === 'suggest' && email !== lastSuggestedEmail) {
        lastSuggestedEmail = email;
        errorEl.textContent = '';
        errorEl.hidden = false;
        errorEl.appendChild(
          window.AweEmailTypoCheck.buildSuggestionMarkup(typoCheck.correctedEmail, () => {
            input.value = typoCheck.correctedEmail;
            errorEl.textContent = '';
            errorEl.hidden = true;
            lastSuggestedEmail = null;
            subscribe(typoCheck.correctedEmail);
          })
        );
        return;
      }

      lastSuggestedEmail = null;
      await subscribe(email);
    });
  }

  document.querySelectorAll('.awe-klaviyo-form').forEach(initForm);
})();
